module.exports = __webpack_public_path__ + "img/info.9c037523.svg";